import "../k";
import { Vec2 } from "kaplay";

function addButton(spriteName: string, comps?: any[], size?: Vec2) {
  const button = add([
    sprite(spriteName),
    area(),
    color(Color.WHITE),
    anchor("center"),
    { isEnabled: true },
    ...comps,
  ]);

  const initialColor = button.color;

  if (size) {
    button.width = size.x;
    button.height = size.y;
  }

  if (button.textContents) {
    button.add([
      text(button.textContents, {
        font: "rumeur",
        size: 24,
        width: button.width * 0.9,
        align: "center",
      }),
      color(0, 0, 0),
      anchor("center"),
    ]);
  }

  let isHovered = false;
  button.onHoverUpdate(() => {
    if (button.isEnabled) {
      const t = time() * 10;
      const pulse = Math.sin(t) * 10 + 230;
      const grow = Math.sin(t) * 0.01 + 1.02;
      button.scale = vec2(grow, grow);
      button.color = rgb(
        initialColor.r * (pulse / 255),
        initialColor.g * (pulse / 255),
        initialColor.b * (pulse / 255)
      );
      setCursor("pointer");
      if (!isHovered) {
        play("rollover", { volume: 0.2 });
        isHovered = true;
      }
    }
  });

  button.onHoverEnd(() => {
    if (button.isEnabled) {
      button.scale = vec2(1, 1);
      button.color = initialColor;
      setCursor("default");
      isHovered = false;
    }
  });

  button.onClick(() => {
    if (button.isEnabled) {
      play("click", { volume: 0.5 });
    }
  });

  return button;
}

export { addButton };
